/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AidDto } from './AidDto';
import {
    AidDtoFromJSON,
    AidDtoFromJSONTyped,
    AidDtoToJSON,
} from './AidDto';
import type { MultisigMemberDto } from './MultisigMemberDto';
import {
    MultisigMemberDtoFromJSON,
    MultisigMemberDtoFromJSONTyped,
    MultisigMemberDtoToJSON,
} from './MultisigMemberDto';

/**
 * 
 * @export
 * @interface CreateMultisigResponse
 */
export interface CreateMultisigResponse {
    /**
     * 
     * @type {AidDto}
     * @memberof CreateMultisigResponse
     */
    multisigAid?: AidDto;
    /**
     * 
     * @type {Array<MultisigMemberDto>}
     * @memberof CreateMultisigResponse
     */
    members?: Array<MultisigMemberDto>;
}

/**
 * Check if a given object implements the CreateMultisigResponse interface.
 */
export function instanceOfCreateMultisigResponse(value: object): boolean {
    return true;
}

export function CreateMultisigResponseFromJSON(json: any): CreateMultisigResponse {
    return CreateMultisigResponseFromJSONTyped(json, false);
}

export function CreateMultisigResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMultisigResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'multisigAid': json['multisigAid'] == null ? undefined : AidDtoFromJSON(json['multisigAid']),
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(MultisigMemberDtoFromJSON)),
    };
}

export function CreateMultisigResponseToJSON(value?: CreateMultisigResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'multisigAid': AidDtoToJSON(value['multisigAid']),
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map(MultisigMemberDtoToJSON)),
    };
}

